var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Badge徽标数
 * @author zhuwanying02
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { isString } from 'lodash-es';
import './index.less';
import { classPrefix } from '../../common/util';

/**
* 参数说明
*
* className     可选,组件根节点上添加类
* classPrefix   可选,类名前缀
* style         可选,组件根节点上添加样式
* supStyle      可选,徽标内容添加样式
* count         可选,徽标数字
* overflowCount 可选,最大值,当count超出最大值,显示overflowCount+,默认值99
* showZero      可选,设置count为0的时候是否显示
* showDot       可选,不显示具体数字,显示红点
**/

var Badge = function (_Component) {
    _inherits(Badge, _Component);

    function Badge() {
        _classCallCheck(this, Badge);

        return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
    }

    _createClass(Badge, [{
        key: 'renderBadge',
        value: function renderBadge() {
            var _classnames;

            var _props = this.props,
                count = _props.count,
                showZero = _props.showZero,
                supStyle = _props.supStyle,
                showDot = _props.showDot,
                overflowCount = _props.overflowCount,
                classPrefix = _props.classPrefix;

            var badgeClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-badge-count', !showDot), _defineProperty(_classnames, classPrefix + '-badge-dot', showDot), _classnames));
            var countText = void 0;
            if (isString(count)) {
                countText = count;
            } else {
                countText = showDot ? '' : count > overflowCount ? overflowCount + '+' : count;
            }

            if (showDot || showZero || count > 0 || isString(count)) {
                return React.createElement(
                    'sup',
                    { className: badgeClass, style: supStyle },
                    countText
                );
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames2;

            var _props2 = this.props,
                className = _props2.className,
                classPrefix = _props2.classPrefix,
                style = _props2.style,
                children = _props2.children;

            var rootClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-badge-root', true), _defineProperty(_classnames2, classPrefix + '-badge-wrapper', children), _defineProperty(_classnames2, className, true), _classnames2));

            return React.createElement(
                'div',
                { className: rootClass, style: style },
                children,
                this.renderBadge()
            );
        }
    }]);

    return Badge;
}(Component);

export default Badge;


Badge.defaultProps = {
    overflowCount: 99,
    showZero: false,
    showDot: false,
    classPrefix: classPrefix
};

Badge.propTypes = {
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    overflowCount: PropTypes.number,
    showZero: PropTypes.bool,
    showDot: PropTypes.bool,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    supStyle: PropTypes.object,
    children: PropTypes.node
};